import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useDebouncedCallback } from 'use-debounce';

import Button from '~/components/base/Button';
import Icon from '~/components/base/Icon';

import { dynamicFontSize } from '~/utilities/helpers';

import { h5 } from '~/styles/typography';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
`;

const StyledButton = styled(Button)`
    font-size: ${dynamicFontSize(0.8, 1.2, 1.6)};
`;

const Amount = styled.p`
    ${h5};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    margin-top: 2px;
`;

const QuantityButtons = ({
    defaultQuantity,
    onChangeQuantity,
    className,
    min = 1,
    step = 1
}) => {
    const [quantity, setQuantity] = useState(defaultQuantity);
    const debouncedUpdate = useDebouncedCallback((newValue) => {
        onChangeQuantity(newValue);
    }, 500);

    useEffect(() => {
        debouncedUpdate(quantity);
    }, [quantity, debouncedUpdate]);

    return (
        <Wrapper {...{ className }}>
            <StyledButton
                onClick={() => setQuantity(quantity - step)}
                buttonSize="mini"
                disabled={defaultQuantity === min}
            >
                <Icon icon="minus" size={12} color="textBlack" />
            </StyledButton>
            <Amount>{quantity}</Amount>
            <StyledButton
                onClick={() => setQuantity(quantity + step)}
                buttonSize="mini"
            >
                <Icon icon="plus" size={12} color="textBlack" />
            </StyledButton>
        </Wrapper>
    );
};

QuantityButtons.propTypes = {
    defaultQuantity: PropTypes.number.isRequired,
    onChangeQuantity: PropTypes.func.isRequired,
    min: PropTypes.number,
    step: PropTypes.number,
    className: PropTypes.string
};

export default QuantityButtons;
